import Helmet from 'react-helmet';
import {
    SUITS_ME_APP_STORE,
    SUITS_ME_EMAIL,
    SUITS_ME_GOOGLE_PLAY_STORE,
} from 'lib/constants/routes';
import { customerSupportNumber } from 'lib/constants/contactInfo';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import SuitsMeLogo from '_content/images/logos/SuitsMe_Logo_Gradient.svg';
import AppStoreBadge from '_content/images/app-store/app-store-badge.png';
import GooglePlayBadge from '_content/images/app-store/google-play-badge.png';

const MaintenancePage = () => (
    <div className="login-container maintenance">
        <Helmet>
            <title>Maintenance | Suits Me Banking</title>
        </Helmet>
        <img src={SuitsMeLogo} alt="Suits Me" className="logo mt-4" />
        <Typography tag="h1" className="mt-4">
            Suits Me web account access has now ended
        </Typography>
        <Typography tag="p" className="mt-2">
            You can no longer sign in to manage your account through our
            website.
        </Typography>
        <Typography tag="p" className="mt-2">
            To access and manage your account online, you&apos;ll need to use
            the Suits Me app. If you need help getting started, or you
            don&apos;t have a suitable smartphone, please contact our team.
        </Typography>
        <Typography tag="p" className="mt-2">
            <strong>Contact us:</strong> {customerSupportNumber} or email{' '}
            <a href={SUITS_ME_EMAIL}>hello@suitsmecard.com</a>.
        </Typography>
        <Typography tag="p" className="mt-2">
            Your Suits Me account remains open, and your money remains yours.
        </Typography>
        <div className="maintenance__badges">
            <a
                href={SUITS_ME_APP_STORE}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={AppStoreBadge} alt="Download on the App Store" />
            </a>
            <a
                href={SUITS_ME_GOOGLE_PLAY_STORE}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={GooglePlayBadge} alt="Get it on Google Play" />
            </a>
        </div>
    </div>
);

export default MaintenancePage;
